import {AxiosRequestConfig} from "axios";
import ApiService from "@/services/api.service";


const SubmissionsService = {
    setSubmissions: async function(data: any) {
        console.log(Object.fromEntries(data))

        // const requestData: AxiosRequestConfig = {
        //     method: "post",
        //     headers: {
        //         "Content-Type": "application/x-www-form-urlencoded"
        //     },
        //     url: "/user/submissions",
        //     data: qs.stringify(Object.fromEntries(data))
        // };
        //
        // try {
        //     const response = await ApiService.customRequest(requestData)
        //
        //     console.log(response.data)
        // } catch (error) {
        //     console.log('submissionsError', error)
        // }
    },

    getSubmissions: async function() {
        const requestData: AxiosRequestConfig = {
            method: "get",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            url: `/client/submissions`
        };

        try {
            return (await ApiService.customRequest(requestData)).data;
        } catch (error) {
            console.log('submissionsError', error)
        }
    },
}


export { SubmissionsService };
